import { Field, FieldFooter } from '@busybusy/webapp-react-ui';
import classNames from 'classnames';
import EquipmentMakeForCategoryPicker, {
  IEquipmentMakePickerProps,
} from 'components/domain/equipment/EquipmentMakesForCategoryPicker/EquipmentMakesForCategoryPicker';

interface IEquipmentMakeFormFieldProps extends Omit<IEquipmentMakePickerProps, 'value' | 'onSelect'> {
  className?: string | object;
  form: any;
  equipmentCategoryId: string | null | undefined;
  name: string;
  onChange?: (value: string | null) => void;
  validations?: any;
}

function EquipmentMakeFormField(props: IEquipmentMakeFormFieldProps) {
  const { form, name, equipmentCategoryId, validations, className, onChange, ...other } = props;

  const classes = classNames(
    {
      'equipment-make-picker-form-field': true,
    },
    className
  );

  function renderField({ ...fieldProps }) {
    function handleOnSelect(val: string | null) {
      fieldProps.handleChange(val, onChange);
    }

    return (
      <>
        <EquipmentMakeForCategoryPicker
          error={fieldProps.hasError}
          value={form.state.data[name]}
          onSelect={handleOnSelect}
          equipmentCategoryId={equipmentCategoryId}
          {...other}
        />
        <FieldFooter errorMessage={fieldProps.errorMessage} hasError={fieldProps.hasError} />
      </>
    );
  }

  return <Field form={form} name={name} validations={validations} className={classes} render={renderField} />;
}

export default EquipmentMakeFormField;
